import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import { storeActivityIndicator } from '../../../../../redux/reducers/authSlice';
import CustomDatePicker from '../../../../../components/CustomDatePicker';
import { cekimAraligiHatasi, sonCalismaYaz, varsayilanCekimAraligi } from '../../../../../helpers/yakitAktarim';
import { YakitService } from '../../../../../services/YakitService';

interface Props {
    show: boolean
    sonCalisma: string | null | undefined
    onClose: () => void
    /** Çekim kuyruğa alınınca (pencere kapanır; liste entegrasyon durumunu yeniler). */
    onCekildi: () => void
}

/**
 * Yakıt Kayıtları · Petrol Ofisi'nden çek (04.11.2026, #547).
 * A1 Açılış: Başlangıç = bugün − 6, Bitiş = bugün; son çekim zamanı gösterilir.
 * R1 "Bağlantıyı test et" → Yakit/PetrolOfisiTest; sonuç toast (başarı mesajı ya da hata).
 * R2 "Çek" → tarih aralığı denetlenir → Yakit/PetrolOfisiCek; dönen mesaj toast, pencere kapanır. İş kuyruğa alınır;
 *    eşleşmeyen satışlar Aktarım Hataları ekranına düşer.
 */
const PetrolOfisiCekModal = ({ show, sonCalisma, onClose, onCekildi }: Props) => {
    const dispatch = useDispatch();
    const [baslangic, setBaslangic] = useState<string | undefined>(undefined);
    const [bitis, setBitis] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (!show)
            return;
        const a = varsayilanCekimAraligi();
        setBaslangic(a.baslangic);
        setBitis(a.bitis);
    }, [show])

    const test = async () => {
        try {
            dispatch(storeActivityIndicator(true));
            var response = await YakitService.petrolOfisiTest();
            if (!response.isSuccess) {
                toast.error(response.message ?? 'Bağlantı kurulamadı.');
                return;
            }
            toast.success(response.data ?? 'Bağlantı başarılı.');
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const cek = async () => {
        const hata = cekimAraligiHatasi(baslangic, bitis);
        if (hata) {
            toast.error(hata);
            return;
        }
        try {
            dispatch(storeActivityIndicator(true));
            var response = await YakitService.petrolOfisiCek(baslangic, bitis);
            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                return;
            }
            toast.success(response.data ?? 'Çekim kuyruğa alındı.');
            onCekildi();
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Petrol Ofisi'nden çek</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-6">
                        <CustomDatePicker labelText="Başlangıç" isLabelRequired value={baslangic} setValue={setBaslangic} />
                    </div>
                    <div className="col-6">
                        <CustomDatePicker labelText="Bitiş" isLabelRequired value={bitis} setValue={setBitis} />
                    </div>
                </div>

                <div className="text-muted fs-7 mt-4">
                    Son çekim: <b>{sonCalismaYaz(sonCalisma)}</b>
                </div>
                <div className="text-muted fs-7 mt-2">
                    Seçilen aralıktaki satışlar arka planda çekilir ve yakıt fişi olarak kaydedilir. Fişe dönüştürülemeyen satışlar
                    (ör. araç bulunamadı) Aktarım Hataları ekranına düşer.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-light-primary me-auto" onClick={test}><i className="fa fa-plug me-1" />Bağlantıyı test et</button>
                <button className="btn btn-sm btn-light" onClick={onClose}>Kapat</button>
                <button className="btn btn-sm btn-primary" onClick={cek}>Çek</button>
            </Modal.Footer>
        </Modal>
    )
}

export default PetrolOfisiCekModal;
